module.exports = __webpack_public_path__ + "img/product_35.08c572c.jpg";